/**
* Site navigation.
* Desktop mega menu and mobile navigation which uses - http://mmenu.frebsite.nl/
*/

import $ from 'jquery';

// Cached elements
const $el = {
	sitesNavToggle: $('.js-sites-nav-toggle'),
	sitesNavToggleparent: $('.js-sites-nav-toggle').closest('li'),
	sitesNav: $('.js-sites-nav').not('.mm-listview'),
	sitesList: $('.js-sites-nav').closest('ul').find('.c-sites-nav__inner'),
};


export default function init() {
	
	// Move the correct site to first place
	setActiveItem();
	
	$.each($el.sitesNav, function() {
		$(this).find('li:first').siblings().wrapAll('<div class="c-sites-nav__inner">');
	});
	
	$el.sitesList = $el.sitesNavToggle.closest('ul').find('.c-sites-nav__inner');
	
	bindEvents();
}

function setActiveItem() {
	$el.sitesNavToggle.prependTo($el.sitesNav).addClass('is-ready');
}

function bindEvents() {
	$el.sitesNavToggle.on('click', function(e) {
		e.preventDefault();
		toggleSitesList($(this));
	});
	// Close the country list if you click anywhere on the document except inside the .c-sites-nav container
	$(document).on('click', function(e) {
		if (!$(e.target).closest('.js-sites-nav').length) {
			closeSitesList();
		}
	});
}

function toggleSitesList() {
	$el.sitesList.slideToggle({ easing: 'easeInOutQuart' }).toggleClass('is-open');
	$el.sitesNavToggleparent.toggleClass('is-open');
}

function closeSitesList() {
	$el.sitesList.slideUp({ easing: 'easeInOutQuart' }).removeClass('is-open');
	$el.sitesNavToggle.removeClass('is-open');
	$el.sitesNavToggleparent.removeClass('is-open');
}